import { handleConsentOverlay } from "@sazka/utils/gdpr/consent-overlay";
import { eventBus, GlobalEvents } from "@sazka/utils/global-events";

async function initConsentOverlay() {
    await showConsentOverlay();

    eventBus.on(GlobalEvents.ConsentsChanged, async () => {
        await showConsentOverlay();
    });
}

async function showConsentOverlay() {
    const elements = document.querySelectorAll(".editable-text-video");
    if (!elements || !elements.length) return;

    elements.forEach(async (el) => {
        const element = el as HTMLElement;
        const embedUrl = createEmbedUrl(element.dataset.videoCode, element.dataset.platform);

        const overlayAdded = await handleConsentOverlay(element, embedUrl, null, 300);

        if (!overlayAdded) {
            const height = parseInt(element.dataset.height);
            const width = element.dataset.width;
            element.innerHTML = `<iframe src="${embedUrl}"${isNaN(height) ? "" : ` height="${height}"`}${
                !width ? "" : ` width="${width}"`
            } allowfullscreen></iframe>`;
        }
    });
}

function createEmbedUrl(videoCode: string, platform: string) {
    switch (platform) {
        case "youtube":
            return `//www.youtube-nocookie.com/embed/${videoCode}`;
        case "facebook":
            return `${videoCode}`;
        case "twitch-channel":
            return `https://player.twitch.tv/?channel=${videoCode}&parent=${window.location.hostname}`;
        case "twitch-video":
            return `https://player.twitch.tv/?video=${videoCode}&parent=${window.location.hostname}`;
        case "twitch-clip":
            return `https://clips.twitch.tv/embed?clip=${videoCode}&parent=${window.location.hostname}`;
        case "google-form":
            return `${videoCode}`;
    }
}

export function useEditableVideosGdprOverlay() {
    document.ready(initConsentOverlay);
}
